module.exports = __webpack_public_path__ + "img/companyIntro21.8235dfdf.png";